import React from 'react';
// Make sure to import the updated CSS file
import './CTA.css';

function CTA() {
  return (
    // Use the new unique base class 'AboutCTA'
    <section className="AboutCTA">
      <div className="container">
        {/* New unique class for the title */}
        <h4 className="AboutCTA__title">
          Ready to unleash the power of AI customer service agents?
        </h4>
        
        {/* New unique class for the button */}
        <a href="#contact" className="AboutCTA__button">
          Contact sales
        </a>
      </div>
    </section>
  );
}

export default CTA;